module.exports = __webpack_public_path__ + "static/biopunkkitchen-noBg-centered-80a04083b56a95089d1241beb16d5b63.svg";